import { HelpOutline } from "@mui/icons-material";
import React, { useState } from "react";
import Modal from "../../common/Modal/Modal";
import "./datarequeststooltips.css";

/**
 * Tooltips for the Data Requests page
 */

export default function DataRequestsTooltips() {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // Close the success modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <div className="datarequest-tooltips-container">
      <button className="datarequest-tooltips-button" onClick={handleOpenModal}>
        <HelpOutline />
      </button>
      <Modal
        isOpen={openModal}
        onClose={handleCloseModal}
        title={"Requesting Data"}
        showCustomContent={true}
        customContent={
          <div className="datarequest-body">
            <div className="datarequest-description">
              You can assign properties to your team and they will be notified
              through WhatsApp. The request will be marked as complete once the
              requested data has been submitted and you can merge the received
              data with your form.
            </div>
            <div className="datarequest-description">
              Requests <span>cannot </span>be edited once they have been sent.
              If you made a mistake you must delete and resend the request.
            </div>
            <div>
              <div className="datarequest-description">
                <span className="datarequest-inprogress">In Progress: </span>The
                data request has been sent to the recipient.
              </div>
              <div className="datarequest-description">
                <span className="datarequest-complete">Completed: </span> The
                request from has been completed by the recipient and submitted
                back to you.{" "}
              </div>
              <div className="datarequest-description">
                <span className="datarequest-merged">Merged: </span>You have
                merged the requested data with your form.
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}
